<div class="errorContainer">
  <div class="errorWrapper" *ngIf="!errorViewModel.type">
    <p class="sentimentIcon text-secondary"><span class="material-symbols-outlined">sentiment_dissatisfied</span></p>
    <p class="errorMessage text-secondary" [innerHTML]="errorViewModel.message"></p>
  </div>
</div>
